import * as CONST from '../../../constants';

const INITIAL_STATE = { loading: true, myfatoorah: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.MYF_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, myfatoorah: null, error: null };
    case CONST.MYF_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, myfatoorah: action.myfatoorah, error: null };
    case CONST.MYF_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, myfatoorah: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, myfatoorah: null };
    default:
      return state;
  }
};
